import { Component, createRef } from 'react';
import {Button, Modal} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import {history} from '../../../store';

import './style.css';

class LockPopup extends Component {
  containerRef = createRef();

  close() {
    this.setState(() => ({show: false}));
    if (this.props.route) {
      history.push(this.props.route);
    }
  }

  render() {
    return (
      <div ref={this.containerRef} className="modal-container" style={{height: 200}}>

        <Modal
          aria-labelledby="contained-modal-title"
          container={this.containerRef}
          show
        >

          <Modal.Body>
            Your account has now been locked to keep it secure.
            Please
            {' '}
            <Link to="/contact">
              click here to contact us
            </Link>
            {' '}
            so that we can help you access your account
            <br/>
            <Button className="grey-ghost-btn" onClick={this.close.bind(this)}>
              CLOSE
            </Button>
          </Modal.Body>

        </Modal>
      </div>
    );
  }
}

export default LockPopup;
